import categoryService from '@services/category';
import { getLanding, getVendorByDomainServerSide } from '@services/vendor';
import type { GetServerSideProps, NextPage } from 'next';
import { ReactElement } from 'react';
import BaseLayout from '../components/layouts/baseLayout';
import LandingLayout from '../components/layouts/landingLayout';
import HomeScreen from '../features/user/home/homeScreen';
import { HomePageWithLandingProps } from '../features/user/home/types';
import { safeString } from '../utils/stringUtil';
import VendorUtil from '../utils/vendorUtils';

const Home: NextPage<HomePageWithLandingProps> = ({ vendor }) => {
  let layout: ReactElement;

  if (vendor?.landing?.vendors?.length) {
    const { landing } = vendor;
    layout = <LandingLayout vendor={{ ...vendor, landing }} />;
  } else {
    layout = <HomeScreen vendor={vendor} />;
  }
  return <BaseLayout>{layout}</BaseLayout>;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const domain = context.req?.headers?.host;
  const hostDomain = VendorUtil.parseVendorDomain(safeString(domain));

  const requests = [
    getVendorByDomainServerSide(hostDomain),
    categoryService?.getMenuCategoriesServerSideWithMenuItems(hostDomain),
    getLanding(hostDomain),
  ];

  const [vendor, menuCategories, landing] = await Promise.all(
    requests.map(async (reqHandler) => (await reqHandler).data)
  );

  context.res.setHeader('Cache-Control', 'no-store');
  return {
    props: { vendor: { ...vendor, landing, menuCategories } },
  };
};

export default Home;
